<div [class.dark-theme]="true" class="fix-action-dialog">
	<div fxLayout="row" fxlayoutalign="space-between">
		<h3 data-idtest="aigia-login-dialog-t-9Kz" mat-dialog-title style="color: #ffffff;">{{content.title}}</h3>
	</div>
	<mat-dialog-content fxLayout="column" style="background-color: #24242480;">
		<div fxLayout="column" style="margin:16px;font-size: 14px;">
			<form #form="ngForm" fxLayout="column" fxLayoutAlign="space-between" novalidate>
				<mat-form-field appearance="outline" style="margin:6px;height: 80px;">
					<mat-label><span data-idtest="aigia-login-dialog-t-7Gf" translate>メールアドレス</span></mat-label>
					<input #username="ngModel" [(ngModel)]="content.username" autocomplete="off" email matInput maxlength="255" minlength="3" name="username" placeholder="{{ 'メールアドレス' | translate }}" required type="email" style="color: #ffffff">
					<mat-error *ngIf="username.errors?.['email'];"><span translate>有効なメールアドレスで</span></mat-error>
					<mat-error *ngIf="username.errors?.['required'];"><span translate>入力してください</span></mat-error>
					<mat-error *ngIf="username.errors?.['maxlength'];"><span translate>長すぎます</span></mat-error>
					<mat-error *ngIf="username.errors?.['minlength'];"><span translate>短すぎます</span></mat-error>
				</mat-form-field>
				<div fxLayout="row" fxLayoutAlign="center center" style="margin:6px;">
					<mat-form-field appearance="outline" fxFlex="90">
						<mat-label><span data-idtest="aigia-login-dialog-t-7At" translate>パスワード</span></mat-label>
						<div *ngIf="password_visible; then visible_input; else invisible_input"></div>
						<ng-template #visible_input>
							<input #password="ngModel" [(ngModel)]="content.password" matInput maxlength="100" name="password" placeholder="{{ 'パスワード' | translate }}" required type="text">
						</ng-template>
						<ng-template #invisible_input>
							<input #password="ngModel" [(ngModel)]="content.password" matInput maxlength="100" name="password" placeholder="{{ 'パスワード' | translate }}" required type="password" style="color: #ffffff">
						</ng-template>
					</mat-form-field>
					<button (click)="password_visible = !password_visible;" fxFlex="10" mat-button mat-icon-button matSuffix style="margin-top: -24px; color: #ffffff;">
						<div *ngIf="password_visible; then visible_icon; else invisible_icon"></div>
						<ng-template #visible_icon>
							<mat-icon>visibility</mat-icon>
						</ng-template>
						<ng-template #invisible_icon>
							<mat-icon>visibility_off</mat-icon>
						</ng-template>
					</button>
				</div>
			</form>
			<div fxFlex="100" fxLayout="column" fxLayoutAlign="center" fxLayoutAlign.lt-sm="center" fxLayoutGap="24px">
				<div fxFlex="60" fxLayoutAlign="center">
					<button (click)="onAccept()" [disabled]="form.invalid || isProgress" color="primary" fxFlex="60" mat-raised-button><span data-idtest="aigia-login-dialog-t-0Zs" translate>ログイン</span></button>
				</div>
				<div fxFlex="60" fxFlex.lt-sm="100" fxLayoutAlign="center">
					<button data-idtest="aigia-login-dialog-b-9Ma" [disabled]="isProgress" aigia-password-button color="primary" fxFlex="60" fxFlex.lt-sm="100" mat-raised-button><span data-idtest="aigia-login-dialog-t-0Oz" translate>パスワードをお忘れの方はこちら></span></button>
				</div>
			</div>
		</div>
	</mat-dialog-content>
	<mat-dialog-actions fxLayoutAlign="center" fxLayoutAlign.lt-sm="center">
		<div fxFlex="60" fxLayout="column" fxLayout.lt-sm="column" fxLayoutAlign="center" fxLayoutAlign.lt-sm="center">
			<button aigia-regist-button2 color="primary" fxlayoutalign="center" mat-raised-button>
				<mat-icon>person_add</mat-icon>
				<span data-idtest="aigia-login-dialog-t-6St" translate>新規登録</span>
			</button>
			<button [disabled]="isProgress" color="warn" mat-dialog-close="" mat-stroked-button style="margin: 12px;"><span data-idtest="aigia-login-dialog-t-3Cp" translate>キャンセル</span></button>
		</div>
	</mat-dialog-actions>
</div>
